import { createContext } from 'react'
import { createContextualCan } from "@casl/react"
import { Ability } from '@casl/ability';
import ability from './ability';

export const AbilityContext = createContext<Ability>(ability)
export const Can = createContextualCan(AbilityContext.Consumer);

export default Can;